import { removeStyleTag, upsertStyleTag } from "../../domStyles";

const STYLE_ID = "incluway-align-text-style";
const EXCLUDE = "#incluway-widget-root";

const TEXT_ELEMENTS = `
:where(
  p,span,a,li,td,th,div,section,article,
  header,footer,nav,
  h1,h2,h3,h4,h5,h6,
  button,label,input,textarea,select
)
`;

export function setAlign(direction: "left" | "center" | "right") {
  upsertStyleTag(
    STYLE_ID,
    `
body[data-incluway-align] ${TEXT_ELEMENTS}
  :not(${EXCLUDE}):not(${EXCLUDE} *) {
  text-align: var(--incluway-text-align) !important;
}
`.trim(),
  );

  document.body.dataset.incluwayAlign = direction;
  document.body.style.setProperty("--incluway-text-align", direction);
}

export function clearAlign() {
  delete document.body.dataset.incluwayAlign;
  document.body.style.removeProperty("--incluway-text-align");

  removeStyleTag(STYLE_ID);
}
